// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Pr8F","right":"Footer_right__1pkYb","buttons":"Footer_buttons__2qMQV"};